// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-29cc8e0e] {\n  margin-bottom: 24px;\n}\n.input-number-left[data-v-29cc8e0e] {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
